export const IMAGES = {
  logo: "/images/logo-aura.jpg",
  hero: "/images/hero/hero.jpg",
  community1: "/images/ministry/o-ministerio.jpg",
  community2: "/images/ambassadors/embaixadoras.jpg",
  missAura: "/images/miss-aura/vanessa-vieira.jpg",
  charity: "/images/events/impacto-social.jpg",
  charitySection: "/images/charity/caridade-legado.jpg",
  event1: "/images/events/aura-amanhecer.jpg",
  event2: "/images/events/jantares-executivos.jpg",
  event3: "/images/events/gala-miss-aura.jpg",
  client: "/images/client/cliente-profissional.jpg",
};

export const PILLARS = ["FÉ", "PROFISSÃO", "CUIDADO", "CONEXÃO", "SERVIÇO", "PROPÓSITO", "LEGADO"];

export const DNA_STEPS = [
  { title: "IDENTIDADE", description: "Reconheça quem você é: filha de um Rei, com identidade, propósito e lugar." },
  { title: "IMAGEM", description: "Cuide da mulher que Deus confiou a você, por dentro e por fora." },
  { title: "POSICIONAMENTO", description: "Conheça o seu valor e ocupe o seu lugar com dignidade." },
  { title: "LIFESTYLE", description: "Viva uma vida coerente com a sua transformação." },
  { title: "PROPÓSITO", description: "Descubra como a sua vida pode servir a outras mulheres." },
  { title: "LEGADO", description: "Transforme o que recebeu em algo que permanece para gerações." },
];

export const CATEGORIES = [
  { id: "saude", label: "Saúde", items: ["Psicólogas", "Nutricionistas", "Fisioterapeutas", "Médicas"] },
  { id: "direito", label: "Direito", items: ["Advogadas", "Mediatoras", "Consultoras Jurídicas", "Notárias"] },
  { id: "casa-arquitetura", label: "Casa & Arquitetura", items: ["Arquitetas", "Designers de Interiores", "Organizadoras", "Paisagistas"] },
  { id: "beleza-estetica", label: "Beleza & Estética", items: ["Cabeleireiras", "Esteticistas", "Maquiadoras", "Manicures"] },
  { id: "negocios", label: "Negócios", items: ["Consultoras", "Mentoras de Carreira", "Contadoras", "Gestoras"] },
  { id: "educacao", label: "Educação", items: ["Professoras", "Pedagogas", "Coachs de Idiomas", "Tutoras"] },
  { id: "servicos", label: "Serviços", items: ["Fotógrafas", "Confeiteiras", "Cerimonialistas", "Costureiras"] },
  { id: "moda-lifestyle", label: "Moda & Lifestyle", items: ["Consultoras de Imagem", "Estilistas", "Personal Stylists", "Brechós"] },
  { id: "financas", label: "Finanças", items: ["Planejadoras Financeiras", "Consultoras de Investimento", "Educadoras Financeiras", "Peritas"] },
  { id: "servicos-espirituais", label: "Serviços Espirituais", items: ["Aconselhamento Bíblico", "Mentoria Espiritual", "Intercessão", "Discipulado"] },
];

export const HOW_IT_WORKS = [
  { num: "01", title: "Cadastre-se", text: "Crie sua conta na plataforma AURA em poucos minutos." },
  { num: "02", title: "Comprove sua Identidade Cristã", text: "Um processo simples que protege a confiança de toda a rede." },
  { num: "03", title: "Encontre", text: "Descubra profissionais cristãs verificadas perto de você." },
  { num: "04", title: "Agende", text: "Marque serviços com praticidade, direto pelo aplicativo." },
  { num: "05", title: "Cuide-se", text: "Receba atendimento com excelência e valores compartilhados." },
  { num: "06", title: "Conecte-se", text: "Faça parte de uma comunidade que cresce e serve junta." },
];

export const PRO_VALUES = [
  { title: "Visibilidade", text: "Seja encontrada por milhares de mulheres que buscam exatamente o que você oferece.", icon: "eye" },
  { title: "Conexão", text: "Faça parte de uma rede viva de parcerias, indicações e oportunidades.", icon: "users" },
  { title: "Credibilidade", text: "Um selo de confiança cristã que valoriza o seu trabalho e o seu testemunho.", icon: "badge-check" },
  { title: "Propósito", text: "Transforme o seu talento em serviço e o seu serviço em legado.", icon: "compass" },
  { title: "Comunidade", text: "Cresça ao lado de mulheres que oram, torcem e prosperam com você.", icon: "heart-handshake" },
];

export const EVENTS = [
  { title: "AURA no Amanhecer", text: "Encontros de oração e comunhão ao nascer do sol, para começar o dia na presença de Deus.", icon: "sunrise", image: "event1" },
  { title: "Jantares Executivos", text: "Mesas de conexão para mulheres líderes, profissionais e empreendedoras cristãs.", icon: "utensils", image: "event2" },
  { title: "Gala Miss Aura", text: "A noite mais elegante do movimento: celebração, honra e visão para o futuro.", icon: "crown", image: "event3" },
  { title: "Encontros de Impacto Social", text: "Ações de caridade e serviço que transformam comunidades inteiras.", icon: "globe", image: "charity" },
];

export const ECOSYSTEM_NODES = [
  "MISS AURA",
  "EMBAIXADORAS",
  "PROFISSIONAIS",
  "CLIENTES",
  "SERVIÇOS",
  "TREINAMENTOS",
  "CARIDADE",
  "LEGADO",
  "COMUNIDADE",
];

export const MANIFESTO = [
  "Nós acreditamos que toda mulher carrega um chamado que nenhuma circunstância pode apagar.",
  "Acreditamos na mulher que ora e na mulher que trabalha. Na que cuida do lar e na que dirige empresas. Na que serve em silêncio e na que lidera multidões. Todas filhas do mesmo Rei.",
  "O AURA nasce para conectar o que o mundo separou: fé e profissão, beleza e santidade, prosperidade e serviço, mulher e propósito.",
  "Não somos apenas uma rede. Somos um sacerdócio de mulheres que transformam famílias, cidades e gerações — uma conexão de cada vez.",
  "Servimos porque fomos servidas primeiro. Prosperamos para que outros prosperem. E deixamos legado porque sabemos de onde viemos e para onde vamos.",
];

export const ROLES = {
  MISS_AURA: {
    title: "Quero ser Miss Aura",
    tagline: "Uma das 12 fundadoras e mantenedoras do Ministério.",
    fields: ["name", "phone", "email", "church", "city", "statement"],
  },
  EMBAIXADORA: {
    title: "Quero ser Embaixadora AURA",
    tagline: "A mulher que abre a porta para outras mulheres.",
    fields: ["name", "phone", "email", "church", "city", "instagram"],
  },
};

export const ROLE_CARDS = [
  { role: "MISS_AURA", kind: "application", title: "Miss Aura", description: "Quero conhecer o projeto e me candidatar para fazer parte da liderança AURA.", cta: "QUERO SER MISS AURA", icon: "crown" },
  { role: "EMBAIXADORA", kind: "application", title: "Embaixadora", description: "Quero fazer parte da rede e conectar mulheres, profissionais e serviços.", cta: "QUERO SER EMBAIXADORA", icon: "sparkles" },
  { role: "PROFESSIONAL", kind: "info", title: "Profissional", description: "Profissionais entram diretamente no AuraConect e fazem o cadastro pelo próprio aplicativo, sem precisar de convite.", cta: "CADASTRO DIRETO NO APP", icon: "briefcase" },
  { role: "CLIENT", kind: "info", title: "Cliente", description: "Clientes entram na rede AuraConect através de um convite de uma Miss Aura ou Embaixadora.", cta: "ENTRADA POR CONVITE", icon: "heart" },
];

export const INFO_MODAL = {
  CLIENT: {
    title: "Quer fazer parte da rede Aura?",
    text: "Clientes entram na rede AuraConect através de um convite de uma Miss Aura ou Embaixadora.",
  },
};

// URL oficial do aplicativo AuraConect (entrada direta de Profissionais)
export const AURACONECT_APP_URL = "https://app.auraconect.com.br";

export const FIELD_META = {  name: { label: "Nome completo", placeholder: "Seu nome", required: true },
  phone: { label: "Telefone / WhatsApp", placeholder: "(00) 00000-0000", required: true },
  email: { label: "E-mail", placeholder: "voce@email.com", required: true, type: "email" },
  church: { label: "Igreja / Ministério / Liderança", placeholder: "Onde você congrega ou lidera" },
  city: { label: "Cidade / Estado", placeholder: "São Paulo / SP" },
  instagram: { label: "Instagram", placeholder: "@seuperfil" },
  profession: { label: "Profissão / Especialidade", placeholder: "Ex.: Arquiteta, Psicóloga..." },
  statement: { label: "Declaração de Intenção", placeholder: "Conte-nos por que você deseja ser Miss Aura", textarea: true },
};

// ===== Integrações futuras — preencher quando os links oficiais estiverem definidos =====
// Vídeo de apresentação (Miss Aura Nº 1): URL completa do YouTube. Enquanto null, o vídeo não aparece nos modais.
export const PRESENTATION_VIDEO_URL = "https://youtube.com/shorts/_wE-iw46AU4?si=6eOfFPMxRcpE1fgv";
// Redes sociais oficiais: enquanto url for null, o ícone NÃO aparece no rodapé.
export const SOCIAL_LINKS = [
  { id: "instagram", label: "Instagram", url: "https://instagram.com/ministerioaura" },
  { id: "facebook", label: "Facebook", url: null },
  { id: "youtube", label: "YouTube", url: "https://youtube.com/ministerioaura" },
  { id: "tiktok", label: "TikTok", url: "https://tiktok.com/ministerioaura" },
  { id: "linkedin", label: "LinkedIn", url: null },
  { id: "whatsapp", label: "WhatsApp Business", url: "https://wa.me/5547920069567" }, // +55 47 92006-9567
];
// Páginas legais: enquanto url for null, o item aparece desabilitado (sem link) no rodapé.
export const LEGAL_LINKS = [
  { id: "termos", label: "Termos de Uso", url: "/termos-de-uso" },
  { id: "privacidade", label: "Política de Privacidade", url: "/politica-de-privacidade" },
];

// Miss Aura Nº 1 — apresentação oficial (seção Miss Aura)
export const MISS_AURA_PROFILE = {
  number: "Miss Aura Nº 1",
  name: "Miss Vanessa Vieira",
  role: "Fundadora do Ministério AURA",
  titles: "Pastora, Missionária, Neuropsicanalista, Mentora e Empresária.",
  quote: "Antes de qualquer título, sou completamente apaixonada por Jesus.",
  bio: [
    "Com uma trajetória de mais de 30 anos, Vanessa Vieira dedica sua vida a servir, ensinar e despertar mulheres para uma vida de identidade, propósito, posicionamento e generosidade.",
    "Mãe de Sara e Davi, compreendeu ao longo de sua caminhada que toda mulher carrega a capacidade de gerar, cuidar, transformar e deixar um legado.",
    "Foi desse chamado que nasceu o AURA: um ministério criado para caminhar ao lado de mulheres, fortalecendo sua identidade, despertando seus dons e encorajando-as a prosperar com propósito, fé e generosidade.",
    "Sua missão é despertar mulheres para ocuparem, com fé, coragem e propósito, o lugar que Deus lhes confiou.",
  ],
  location: "Balneário Camboriú — SC",
};
